module.exports = __webpack_public_path__ + "img/l_huawei_Cloud_S.fb401d4f.svg";